// semeia// semeia-disable-reexport
import { capitalize } from "@ember/string";
import dayjs from "dayjs";

/** Format a date with Intl.RelativeTimeFormat if the date is no more than 3 days old, or DD/MM/YYYY */
export default function relativeFormatter(date: dayjs.ConfigType) {
  const relativeFormatter = new Intl.RelativeTimeFormat("fr", {
    numeric: "auto"
  });
  const days = -dayjs().diff(date, "days");
  const parts = relativeFormatter.formatToParts(days, "day");

  // If we have only one part, we know it will be either "aujourd'hui", "hier" or "avant-hier"
  if (parts.length == 1) return capitalize(parts[0].value);

  // If we have more than 1 part, let's format DD/MM/YYYY
  return `Le ${dayjs(date).format("DD/MM/YYYY")}`;
}
